import _ from "lodash";

export function formatDate(datetime) {
  return new Date(datetime).toISOString().substring(0, 10);
}

export function formatDateTime(datetime) {
  if (!datetime)
  {
    return '';
  }
  return new Date(datetime)
    .toISOString()
    .substring(0, 19)
    .replace(/[^0-9-:]/, " ");
}

export function formatNumber(value) {
  var formatter = new Intl.NumberFormat("se-SV", {
    minimumFractionDigits: 0
  });

  if (!value) {
    value = 0;
  }
  return formatter
    .format(value)
    .replace(/,/g, " ")
    .replace(/[a-zA-Z]+/, "");
}

export function intersect(obj, obj2) {
  var result = {};
  if (typeof obj !== "object" || typeof obj2 !== "object") {
    return result;
  }

  Object.keys(obj).forEach(function(key) {
    if (typeof obj[key] !== "undefined" && obj[key] !== "") {
      if (typeof obj2[key] !== "undefined" && obj2[key] !== "") {
        result[key] = Object.assign({}, obj[key], obj2[key]);
      }
    }
  });
  return result;
}

export function collection_to_array(collection) {
  var result = [];
  if (collection) {
    _.each(collection, function(v, key) {
      result.push({ ...v, key });
    });
  }
  return result;
}

export function add_key(collection) {
  var result = {};
  if (collection) {
    _.each(collection, function(v, key) {
      result[key] = { ...v, key };
    });
  }
  return result;
}

export function remove_empty(object) {
  var result = {};
  if (object) {
    _.each(object, function(v, key) {
      if (v) {
        result[key] = v;
      }
    });
  }
  return result;
}

export function collection_by_keys(collection, keys) {
  var result = [];
  _.each(keys, function(key) {
    if (collection[key]) result.push({ ...collection[key], key: key });
  });
  return result;
}

export function filter_empty_values(obj) {
  var _obj = {};

  if (typeof obj === "object") {
    Object.keys(obj).forEach(function(key) {
      if (typeof obj[key] !== "undefined" && obj[key] !== "") {
        _obj[key] = obj[key];
      }
    });
  }
  return _obj;
}

export function filter_by_key_value(obj, key, value) {
  var _obj = {};

  if (typeof obj === "object") {
    Object.keys(obj).forEach(function(okey) {
      if (typeof obj[okey] !== "undefined") {
        var ovalue = obj[okey];
        if (typeof ovalue[key] !== "undefined" && ovalue[key] === value) {
          _obj[okey] = obj[okey];
        }
      }
    });
  }
  return _obj;
}

export function tree_to_array(collection) {
  var level1 = [];
  var level2 = [];
  if (collection) {
    _.each(collection, function(v, key) {
      if (!v.parentid) {
        level1.push({ ...v, key });
      } else {
        level2.push({ ...v, key });
      }
    });
  }

  level1.sort();
  level2.sort();

  _.each(level2, i => {
    var idx = level1.findIndex(m => m.key === i.parentid);
    level1.splice(idx + 1, 0, i);
  });

  return level1;
}

export function getTotalPrice(campaign, products) {
  var bookings = campaign.bookings;

  if (!bookings || bookings.lengnth < 1) {
    return 0;
  }

  if (!products || products.lengnth < 1) {
    return 0;
  }

  var sums = _.map(campaign.bookings, (b, key) => {
    var p = products[b.productid];
    if (p) {
      return 1 * p.netprice;
    }
    return 0;
  });
  return _.sum(sums);
}




// WEBPACK FOOTER //
// ./src/osutil.js